import { render } from "./ArticlesGallery.vue?vue&type=template&id=56df50ee&scoped=true&ts=true"
import script from "./ArticlesGallery.vue?vue&type=script&lang=ts"
export * from "./ArticlesGallery.vue?vue&type=script&lang=ts"

import "./ArticlesGallery.vue?vue&type=style&index=0&id=56df50ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56df50ee"]])

export default __exports__